export const makeUidPath = (path, uid, hash) =>
	`${path.replace(':uid', uid)}${hash ? `#${hash}` : ''}`;

export default makeUidPath;
